import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSmileFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1C2.375 1 1 2.375 1 12s1.375 11 11 11 11-1.375 11-11S21.625 1 12 1M8.656 16.784a2.9 2.9 0 0 1-.578-.884h7.844c-.127.312-.32.61-.578.884-.724.771-1.93 1.316-3.344 1.316-1.415 0-2.62-.545-3.344-1.316M8 14.1c-.518 0-1.018.213-1.36.59a1.59 1.59 0 0 0-.346 1.566 4.6 4.6 0 0 0 1.05 1.76C8.443 19.188 10.142 19.9 12 19.9s3.556-.712 4.657-1.884a4.6 4.6 0 0 0 1.049-1.76c.19-.6.01-1.173-.346-1.566A1.84 1.84 0 0 0 16 14.1zm5.75-4.6c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M8.5 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
            fill="currentColor"
        />
    </svg>
));
EmojiSmileFilledSize24Glyph.displayName = 'EmojiSmileFilledSize24Glyph';
